<template>
  <v-btn v-bind="$attrs" :class="$style.btn" color="primary" variant="flat">
    <slot />
  </v-btn>
</template>

<script setup lang="ts"></script>

<style lang="scss" module>
.btn {
  :global(.v-btn__content) {
    letter-spacing: normal !important;
    z-index: unset !important;
  }
}
</style>
